import { Button } from "@fluentui/react-components";
import { WarningIcon } from "./icons";
import { Notice } from "./Notice";

interface ConnectionErrorNoticeProps {
  /** Retry handler. TaskPane passes a full add-in reload (reloadAddin). */
  readonly onRetry: () => void;
}

/**
 * Full-pane "couldn't connect" state. Shown when the Studio settings load fails
 * with a non-404 error (network drop, 5xx, timeout) — the ambiguous red
 * "Disconnected" status dot alone left the user with a chat that only failed on
 * send. Unlike AccountNotFoundNotice (a definitive 404 "not set up" state), this
 * is potentially transient, so it offers a Retry button. It is the only notice
 * whose Retry reloads the add-in (re-signs-in and re-establishes the connection).
 */
export function ConnectionErrorNotice({
  onRetry,
}: Readonly<ConnectionErrorNoticeProps>) {
  return (
    <Notice
      icon={<WarningIcon />}
      title="Unable to connect"
      message="AiVA Studio could not be reached. Check the network connection and try again."
      action={
        <Button appearance="primary" onClick={onRetry}>
          Retry
        </Button>
      }
    />
  );
}
